import React, { useState } from 'react';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants';
import ListingPageComponent from '../../../components/ListingPageComponent.js';
import { getApi } from '../../../api/endpoints';
import FiltersPartial from "./FiltersPartial.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const [filtersModel, setFiltersModel] = useState({})

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true

    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true

    },
    {
      ...defaultHeaderConfig,
      label: 'Fixed Unit Rate',
      attr: 'fixed_unit_rate',
      disableSort: true

    },
    {
      ...defaultHeaderConfig,
      label: 'Slot Wise Rates',
      value: (row) => {
        return (
          <div className='d-block'>
            {row.slot_wise_rates.length !== 0 ?
              <table className='table table-bordered border-success'>
                <thead>
                  <tr>
                    <th>No. of Units <br />(In kW)</th>
                    <th>Rate <br />(In Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{row.slot_wise_rates.map((item) => (<div key={item.id}>{item.no_of_units}</div>))}</td>
                    <td>{row.slot_wise_rates.map((item) => (<div key={item.id}>{item.rate}</div>))}</td>
                  </tr>
                </tbody>
              </table> : <div>-</div>}
            {/* {row.slot_wise_rates.map((item) => (
              <div className='d-flex justify-content-around' key={item.id}>
                <div>{item.no_of_units}</div>
                <div>{item.rate}</div>
              </div>
            ))} */}
          </div>
        )
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true

    },
  ]

  return <ListingPageComponent
    key={PAGES.ElectricityServiceProvidersListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.ElectricityServiceProvidersListingPage.name)}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: "Electricity Service Providers" }]}
    listingMutation={getApi('electricityServiceProviders')}
    className="electricity-service-providers-page"
    contentHeading="Service Providers List - Results"
    headers={headers}
    recordsKey="service_providers"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['Name']}
  />
};

export default Index;
